import { uapiConnection } from '../uapiConnection';
import { getMachineDataMapsQuery, MachineDataMapsQueryVariables } from './agVizQuery';
import { MachineDataMapsResponse, MachineDataMap } from './types';

export async function requestAgVizMachineDataMaps(
  variables: MachineDataMapsQueryVariables
): Promise<MachineDataMap[]> {
  const response = (await uapiConnection(
    getMachineDataMapsQuery(variables)
  )) as MachineDataMapsResponse;

  return response?.data?.field?.machineDataMaps?.maps ?? [];
}
